"use strict";

var _templateObject, _templateObject2, _templateObject3, _templateObject4;
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _taggedTemplateLiteral(e, t) { return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, { raw: { value: Object.freeze(t) } })); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey2(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey2(t) { var i = _toPrimitive2(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive2(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports.CustomData = void 0;
var _tsRes = require("ts-res"),
  _kameleoonData = require("../../kameleoonData"),
  _kameleoonError = require("../../kameleoonError"),
  _ = require("./.."),
  _utilities = require("../../utilities"),
  _kameleoonLogger = require("../../logging/kameleoonLogger");
function _defineProperty(a, b, c) {
  return (b = _toPropertyKey(b)) in a ? Object.defineProperty(a, b, {
    value: c,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : a[b] = c, a;
}
function _toPropertyKey(a) {
  var b = _toPrimitive(a, "string");
  return "symbol" == _typeof(b) ? b : b + "";
}
function _toPrimitive(a, b) {
  if ("object" != _typeof(a) || !a) return a;
  var c = a[Symbol.toPrimitive];
  if (void 0 !== c) {
    var d = c.call(a, b || "default");
    if ("object" != _typeof(d)) return d;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === b ? String : Number)(a);
}
var CustomData = /*#__PURE__*/function () {
  function CustomData(a) {
    _classCallCheck(this, CustomData);
    var b = a.customDataIndex,
      c = a.valueMatchType,
      d = a.value,
      e = a.range;
    _defineProperty(this, "customDataIndex", void 0), _defineProperty(this, "matchType", void 0), _defineProperty(this, "conditionValue", void 0), _defineProperty(this, "error", void 0), _defineProperty(this, "range", void 0), this.customDataIndex = b ? +b : null, this.matchType = c, this.conditionValue = d, this.range = e;
  }
  return _createClass(CustomData, [{
    key: "evaluate",
    value: function evaluate(a) {
      var b = a.targetingData;
      if ("number" == typeof this.customDataIndex) {
        var c;
        var _a = null === b || void 0 === b || null === (c = b[_kameleoonData.KameleoonData.CustomData]) || void 0 === c ? void 0 : c[this.customDataIndex];
        if (_a) {
          var _b = _a.value,
            _c = this.checkCondition(_b);
          return this.error ? (0, _tsRes.Err)(this.error) : (0, _tsRes.Ok)(_c);
        }
      }
      return (0, _tsRes.Ok)(this.matchType === _.ValueMatchType.UNDEFINED);
    }
  }, {
    key: "checkCondition",
    value: function checkCondition(a) {
      var _this = this;
      if ("string" != typeof this.conditionValue && this.matchType !== _.ValueMatchType.TRUE && this.matchType !== _.ValueMatchType.FALSE && this.matchType !== _.ValueMatchType.RANGE) return _kameleoonLogger.KameleoonLogger.error(_templateObject || (_templateObject = _taggedTemplateLiteral(["Unexpected condition value for CustomData condition: ", ""])), this.conditionValue), !1;
      var b = this.conditionValue;
      if (this.matchType === _.ValueMatchType.AMONG_VALUES) {
        var c = this.parseArray(b);
        if (!c.ok) return this.error = c.error, !1;
        var d = new Set(c.data);
        return Array.isArray(a) ? a.some(function (a) {
          return d.has(a);
        }) : c.data.includes(a);
      }
      if (this.matchType === _.ValueMatchType.RANGE) {
        var _b2 = this.parseRange(this.range);
        if (!_b2.ok) return this.error = _b2.error, !1;
        var _b2$data = _slicedToArray(_b2.data, 2),
          _c2 = _b2$data[0],
          _d = _b2$data[1],
          e = function e(a) {
            return a >= _c2 && a <= _d;
          };
        return Array.isArray(a) ? a.some(function (a) {
          return e(+a);
        }) : e(+a);
      }
      if (Array.isArray(a)) return a.some(function (a) {
        return _this.checkCondition(a);
      });
      switch (this.matchType) {
        case _.ValueMatchType.CONTAINS:
          return a.includes(b);
        case _.ValueMatchType.EXACT:
          return a === this.conditionValue;
        case _.ValueMatchType.REGULAR_EXPRESSION:
          return _utilities.Parser.parseRegExp(b).test(a);
        case _.ValueMatchType.LOWER:
          return +a < +this.conditionValue;
        case _.ValueMatchType.EQUAL:
          return +a === +this.conditionValue;
        case _.ValueMatchType.GREATER:
          return +a > +this.conditionValue;
        case _.ValueMatchType.TRUE:
          return "true" === a.toLowerCase();
        case _.ValueMatchType.FALSE:
          return "false" === a.toLowerCase();
        default:
          return _kameleoonLogger.KameleoonLogger.error(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["Unexpected comparing operation for CustomData condition: ", ""])), this.matchType), !1;
      }
    }
  }, {
    key: "parseArray",
    value: function parseArray(a) {
      try {
        var b = JSON.parse(a);
        if (Array.isArray(b)) return (0, _tsRes.Ok)(b);
      } catch (b) {
        return _kameleoonLogger.KameleoonLogger.error(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["Failed to parse array: ", " in CustomData condition"])), a), (0, _tsRes.Err)(new _kameleoonError.KameleoonError(_kameleoonError.KameleoonException.AmongValuesCheck, b, a));
      }
      return (0, _tsRes.Ok)([]);
    }
  }, {
    key: "parseRange",
    value: function parseRange(a) {
      return a && 2 === a.length ? (0, _tsRes.Ok)(a) : (_kameleoonLogger.KameleoonLogger.error(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["Failed to parse range: ", " in CustomData condition"])), a), (0, _tsRes.Err)(new _kameleoonError.KameleoonError(_kameleoonError.KameleoonException.RangeCheck, a)));
    }
  }]);
}();
exports.CustomData = CustomData;